export enum Criticity { 
    Low,
    High,
    Fatal
}